import React from 'react';

interface SquareIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const SquareIcon: React.FC<SquareIconProps> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2" y="2" width="16" height="16" rx="2" fill={color ?? props?.style?.color} />
  </svg>
);

export default SquareIcon;
